import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation, Navigate, Route, Routes } from 'react-router-dom';
import Login from '../Components/common/Welcome/Login/Login';
import RecoverPassword from '../Components/common/Welcome/RecoverPassword/RecoverPassword.jsx';
import Register from '../Components/common/Welcome/Register/Register';
import SuperUserAccounts from 'Components/common/Welcome/SuperUser/SuperUserAccounts';
import Appearence from '../Components/Dashboard/Appearence/Appearence';
import BookingList from '../Components/Dashboard/BookingList/BookingList';
import CheckIn from '../Components/Dashboard/CheckIn/CheckIn.jsx';
import CheckInList from '../Components/Dashboard/CheckInList/CheckInList';
import CheckinStats from '../Components/Dashboard/CheckinStats/CheckinStats';
import Hotels from '../Components/Dashboard/Hotels/Hotels';
import LegalDocuments from '../Components/Dashboard/LegalDocuments/DefaultLegalDocuments';
import LegalDocumentsFields from '../Components/Dashboard/LegalDocuments/LegalDocuments';
import PMS from '../Components/Dashboard/PMS/PMS';
import SalesChannels from '../Components/Dashboard/SalesChannels/SalesChannels';
import Users from '../Components/Dashboard/Users/Users';
import PrivateRoute from './PrivateRoute';
import ChangePassword from 'Components/common/Welcome/ChangePassword/ChangePassword';
import CommunicationChannels from 'Components/Dashboard/CommunicationChannels/CommunicationChannels';
import AccountDetail from 'Components/Dashboard/AccountDetail/AccountDetail';
import Marketing from 'Components/Dashboard/Marketing/Marketing';
import SelectPMS from 'Components/common/Welcome/SelectPMS/SelectPMS';
import Support from 'Components/Dashboard/Support/Support';
import RegisterPaperless from '../Components/common/Welcome/RegisterPaperless/RegisterPaperless';
import { AppContext } from 'App.context';
import DoorOpening from 'Components/Dashboard/DoorOpening/DoorOpening';
import PaymentConfiguration from 'Components/Dashboard/PaymentConfiguration/PaymentConfiguration';
import DoorOpeningMaintenance from 'Components/Dashboard/DoorOpening/DoorOpeningMaintenance/DoorOpeningMaintenance';
import MailTemplates from 'Components/Dashboard/Guestlink/MailTemplates/MailTemplates';
import MailTemplateDetail from 'Components/Dashboard/Guestlink/MailTemplateDetail/MailTemplateDetail';
import PaymentList from 'Components/Dashboard/PaymentList/PaymentList';
import PaperlessPush from 'Components/Dashboard/PaperlessPush/PaperlessPush';
import Forms from 'Components/Dashboard/Forms/Forms';
import PoliceReportListPV from 'Components/Dashboard/PoliceReport/PoliceReportList/PV/PoliceReportList';
import PoliceReportListRH from 'Components/Dashboard/PoliceReport/PoliceReportList/RH/PoliceReportList';
import PoliceReportPVDetailSES from 'Components/Dashboard/PoliceReport/PoliceReportDetail/PV/SES/PoliceReportDetail';
import PoliceReportRHDetailsSES from 'Components/Dashboard/PoliceReport/PoliceReportDetail/RH/SES/PoliceReportDetail';
import PoliceReportConfigIntegration from 'Components/Dashboard/PoliceReport/PoliceReportConfig/Integrations/IntegratedPlatform';
import PoliceReportConfigPV from 'Components/Dashboard/PoliceReport/PoliceReportConfig/DataConfig/PV/PVConfigs';
import PoliceReportConfigRH from 'Components/Dashboard/PoliceReport/PoliceReportConfig/DataConfig/RH/RHConfigs';
import UpsellShell from 'Sell/Upsell/Shell/UpsellShell';
import CrossSellShell from 'Sell/CrossSell/Shell/Shell';
import SmtpConfig from 'Components/Dashboard/Guestlink/GuestlinkConfig/GuestlinkConfig';
import BillingConfig from 'Components/Dashboard/Billing/BillingConfig/BillingConfig';
import CheckOutList from 'Components/Dashboard/CheckOutList/CheckOutList';
import ProtectedRoute from './ProtectedRoute';
import ValidateLogin from 'Components/common/Welcome/ValidateLogin/ValidateLogin';
import DefaultInfoTexts from 'Components/Dashboard/InformationTexts/DefaultInfoTexts';
import Sftp from 'Components/Dashboard/SFTP/Sftp';
import { HotelLangSelectionProvider } from 'context/HotelLangSelectionContext';
import Hcn from 'Components/Dashboard/HbxProducts/Hcn/Hcn';
import HbxAutoInvoice from 'Components/Dashboard/HbxProducts/HbxAutoInvoice/HbxAutoInvoice';
import HbxUploadExampleInvoices from 'Components/Dashboard/HbxProducts/HbxUploadExampleInvoices/HbxUploadExampleInvoices';
import HbxUploadTemplates from 'Components/Dashboard/HbxProducts/HbxUploadTemplates/HbxUploadTemplates';

export default function AppRoutes({ isShowingQuickguide }) {
  const { appState, appActions } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const SupportOpener = () => {
    const { appState } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
      const url =
        appState.currentLanguage?.id === 'es'
          ? 'https://academy.civitfun.com/hc/es'
          : 'https://academy.civitfun.com/hc/en-gb';
      window.open(url, '_blank');
      navigate(-1);
    }, [appState, navigate]);

    return null;
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/validate-login/:sessionId" element={<ValidateLogin />} />
      <Route path="/recover" element={<RecoverPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/superuser" element={<SuperUserAccounts />} />
      <Route path="/change-password" element={<ChangePassword />} />

      <Route element={<PrivateRoute />}>
        <Route path="/register-paperless" element={<RegisterPaperless />} />
        <Route path="/" element={<Navigate to="/checkin" replace />} />
        <Route path="/checkin" element={<CheckInList />} />
        <Route path="/booking" element={<BookingList />} />
        <Route path="/payments-list" element={<PaymentList />} />
        <Route path="/stats" element={<CheckinStats />} />
        <Route path="/communication-channels" element={<CommunicationChannels />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/police-report" element={<PoliceReportListPV />} />
        <Route path="/police-report/PV" element={<PoliceReportListPV />} />
        <Route path="/police-report/RH" element={<PoliceReportListRH />} />
        <Route path="/:platform/police-report/PV/:guestId" element={<PoliceReportPVDetailSES />} />
        <Route path="/:platform/police-report/RH/:guestId" element={<PoliceReportRHDetailsSES />} />
        <Route path="/upsell/*" element={<UpsellShell />} />
        <Route path="/cross-sell/*" element={<CrossSellShell />} />
        <Route path="/checkout" element={<CheckOutList />} />
        <Route path="/support" element={<SupportOpener />} />
        <Route path="/appearence" element={<Appearence />} />
        <Route path="/checkin-config" element={<CheckIn />} />
        <Route path="/guest-forms" element={<Forms />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/select-pms" element={<SelectPMS />} />
        <Route path="/users" element={<Users />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/pms" element={<PMS />} />
        <Route path="/dooropening" element={<DoorOpening />} />
        <Route path="/door-maintenance" element={<DoorOpeningMaintenance />} />
        <Route path="/payment" element={<PaymentConfiguration />} />
        <Route path="/channels/*" element={<SalesChannels />} />

        <Route path="/legal" element={<LegalDocuments />} />
        <Route
          path="/legal/*"
          element={
            <HotelLangSelectionProvider>
              <LegalDocumentsFields key={location.pathname} />
            </HotelLangSelectionProvider>
          }
        />
        <Route path="/guestlink" element={<MailTemplates />} />
        <Route path="/guestlink/:postId" element={<MailTemplateDetail />} />
        <Route path="/guestlink-config" element={<SmtpConfig />} />
        <Route path="/account-detail" element={<AccountDetail />} />
        <Route path="/paperless-push" element={<PaperlessPush />} />
        <Route
          path="/police-report-config/integration"
          element={<PoliceReportConfigIntegration />}
        />
        <Route path="/police-report-config/PV" element={<PoliceReportConfigPV />} />
        <Route path="/police-report-config/RH" element={<PoliceReportConfigRH />} />
        <Route path="/billing" element={<BillingConfig />} />
        <Route path="/informationTexts*" element={<DefaultInfoTexts />} />
        <Route path="/sftp-checkin*" element={<Sftp />} />
        <Route path="/hcn*" element={<Hcn />} />
        <Route path="/hbx-auto-invoice*" element={<HbxAutoInvoice />} />
        <Route path="/hbx-upload-invoice*" element={<HbxUploadExampleInvoices />} />
        <Route path="/hbx-upload-templates*" element={<HbxUploadTemplates />} />
      </Route>
    </Routes>
  );
}
